<template>
    <a-modal
        v-model="visible"
        width="900px"
        :title="info?.author_id ? $t('submission.add_author.edit_author' /*编辑作者*/) : $t('submission.add_author.add_author' /*新增作者*/)"
        centered
        @ok="handleOkEvent"
        @cancel="handleCancelEvent"
        class="modal-box"
    >
        <contribute-form ref="contributeFormRef" :list="formList" :model="info"></contribute-form>
        <a-form :form="form">
            <a-form-item :label="$t('submission.add_author.author_org' /*作者所属单位*/)" class="mb10" v-if="isOrg">
                <a-select
                    v-decorator="['org_list', { rules: [{ required: true, message: $t('submission.add_author.select_author_org' /*请选择作者单位*/) }] }]"
                    mode="tags"
                    style="width: 100%"
                    :placeholder="$t('submission.add_author.select_author_org' /*请选择作者单位*/)"
                >
                    <a-select-option v-for="(item, index) in orgSearchList" :key="index" :value="`${item.id}`">
                        {{ item.org_cnname }}
                    </a-select-option>
                </a-select>
            </a-form-item>
            <a-form-item class="mb10" v-if="config?.is_tongxun_author == 1">
                <a-checkbox v-decorator="['is_tongxun_author', { valuePropName: 'checked' }]">{{ $t('submission.add_author.corresponding_author' /*通讯作者*/) }}</a-checkbox>
            </a-form-item>
            <a-form-item class="mb10" v-if="config?.is_fayan_author == 1">
                <a-checkbox v-decorator="['is_fayan_author', { valuePropName: 'checked' }]">{{ $t('submission.add_author.speaking_author' /*发言作者*/) }}</a-checkbox>
            </a-form-item>
        </a-form>
    </a-modal>
</template>
<script>
// 表单字段
const fields = ['author_id', 'is_tongxun_author', 'is_fayan_author', 'org_list'];
import pick from 'lodash.pick';
import contributeForm from '@/components/contribute-form.vue';
import moment from 'moment';
export default {
    name: 'AddAuthor',
    components: { contributeForm },
    props: {},
    data() {
        return {
            visible: false,
            form: this.$form.createForm(this),
            orgList: [],
            orgSearchList: [],
            formList: [],
            info: {},
            channel_id: 0,
            abstract_id: '',
            isOrg: false, // 是否收集单位
            config: {}
        };
    },
    methods: {
        async handleOkEvent() {
            const custom = await this.$refs.contributeFormRef.formVerifyFun();
            this.form.validateFields((errors, values) => {
                if (!errors) {
                    let org = [];
                    console.log(this.orgSearchList);
                    this.orgSearchList.forEach((item, index) => {
                        if (values.org_list.indexOf(`${item.id}`) != -1) {
                            org.push(item);
                        }
                    });
                    values.org_list = org;
                    values.is_tongxun_author = values.is_tongxun_author ? 1 : 0;
                    values.is_fayan_author = values.is_fayan_author ? 1 : 0;
                    if (custom.birthdate) {
                        custom.birthdate = moment(custom.birthdate).format('YYYY-MM-DD');
                    }
                    this.addAbstractAuthor({ ...values, ...custom });
                }
            });
        },
        // 删除一个单位
        handleRemoveEvent(index) {
            this.orgList.splice(index, 1);
        },

        // 关闭模态框并重置表单
        handleCancelEvent() {
            this.visible = false;
            this.form.resetFields();
            this.$refs.contributeFormRef.form.resetFields();
        },
        async showFun(author_id, abstract_id, channel_id, config, type) {
            this.config = config;
            this.abstract_id = abstract_id;
            this.channel_id = channel_id;
            let org_list = [];
            if (author_id) {
                let item = await this.getAuthorInfo(author_id);
                this.info = { ...item, ...item.other_info, author_id };
                this.info.org_list.forEach(item => org_list.push(`${item.id}`));
            } else {
                this.info = {};
            }
            this.visible = true;
            this.$nextTick(() => {
                this.info.is_tongxun_author = this.info.is_tongxun_author == 1 ? true : false;
                this.info.is_fayan_author = this.info.is_fayan_author == 1 ? true : false;
                // 回显作者信息
                this.form.setFieldsValue(pick(this.info, fields));
                this.form.setFieldsValue({ org_list: org_list });
                this.getAuthorFormList(type);
            });
            this.getOrganizeList();
        },
        // 获取作者详情
        getAuthorInfo(author_id) {
            return new Promise((resolve, reject) => {
                author_id = Number(author_id) || 0;
                this.$request.post({ url: 'getAuthorInfo', data: { author_id, abstract_id: this.abstract_id } }).then(res => {
                    resolve(res.data);
                });
            });
        },
        addAbstractAuthor(values) {
            let data = {
                ...values,
                author_id: this.info?.author_id ? this.info.author_id : 0,
                abstract_id: this.abstract_id
            };
            this.$request.post({ url: this.info?.author_id ? 'editAuthorInfo' : 'createAbstractAuthor', data: data }).then(res => {
                if (this.info.author_id) {
                    this.$message.success('修改成功');
                } else {
                    this.$message.success('添加成功');
                }
                this.form.resetFields();
                this.visible = false;
                this.$emit('reset');
            });
        },
        // 获取单位列表
        getOrganizeList() {
            this.$request.post({ url: 'getOrganizeList', data: { abstract_id: this.abstract_id } }).then(res => {
                const { List } = res.data;
                this.orgSearchList = List;
            });
        },
        // 获取用户自定义表单
        getAuthorFormList(type) {
            let channel_id = Number(this.channel_id) || 0;
            this.$request.post({ url: 'getAuthorFormList', data: { abstract_id: this.abstract_id, channel_id, type: type, status: 1 } }).then(res => {
                const { list } = res.data;
                let formList = [];
                list.forEach((item, index) => {
                    if (item.field_code == 'organize_id') {
                        this.isOrg = true;
                    } else {
                        formList.push(item);
                    }
                });
                this.formList = formList;
            });
        }
    },
    created() {
        fields.forEach(v => this.form.getFieldDecorator(v));
    }
};
</script>
<style lang="less" scoped>
.modal-box {
    /deep/.ant-form-item-label {
        line-height: 1.5;
    }
    .author-org {
        width: 100%;
        border: 1px solid #f1f1f1;
        th {
            background-color: #f1f1f1;
        }
        th,
        td {
            line-height: 1.5;
            padding: 5px 8px;
            text-align: center;
        }
        tbody tr {
            border-bottom: 1px solid #f1f1f1;
            td {
                text-align: left;
            }
        }
        .icon-delete {
            padding: 5px;
            font-size: 16px;
            border-radius: 3px;
            color: #fff;
            background-color: @error-color;
        }
    }
}

@media screen and (max-width: 768px) {
    .modal-box {
        /deep/.ant-modal-body {
            padding: 15px;
        }
        .author-org {
            zoom: 0.7;
        }
    }
}
</style>
